import { Directive, HostListener } from '@angular/core';
const $ = require('jquery');

@Directive({ selector: '[destroy-video-on-ended]'})

export class DestroyVideoOnEnded {

  @HostListener('ended', ['$event']) onEnded(event: any) {
    $('.video-modal').modal('hide');
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/directives/destroy-video-on-ended.directive.ts